var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subFrame"},[(_vm.uri)?[_c('object',{attrs:{"data":_vm.fullUrl,"width":"100%","height":"100%"}},[_c('embed',{attrs:{"src":_vm.fullUrl,"width":"100%","height":"100%"}})])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }